import {
  Component, Input
} from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';
import { ANDROID_APP_LINK, IOS_APP_LINK } from '@src/app/core/constants/system-list.constant';

@Component({
  selector: 'app-imagebox-one',
  templateUrl: './imagebox-one.component.html',
  styleUrls: ['./imagebox-one.component.scss'],
  standalone: false,
})
export class ImageboxOneComponent extends CoreClass {
  @Input() image: string = '';
  @Input() gradientimage: string = '';
  @Input() imageStyle: string = '';
  @Input() gradientStyle: string = '';
  @Input() heading: string | null = '';
  @Input() description: string | null = '';
  @Input() showAppBtns: boolean = false;
  @Input() isImageLeft: boolean = false;
  @Input() largimg:string | null = '';
  @Input() smallimg : string | null  = '';

  // An empty link means this tenant has no app on that store.
  hasAppLinks: boolean = !!ANDROID_APP_LINK || !!IOS_APP_LINK;

}
